import './qrLogin.css'
import { SolidQR } from "solid-qr"
import { useI18n } from '../../i18n'

interface QrLoginProps {
    verificationUri?:any
}

export const QrLogin = (props: QrLoginProps) => {
    const {getI18n} = useI18n()
    const queryParameters = JSON.parse(props?.verificationUri)
    return (
        <>
                <div class="qr-code-container">
                    <div>
                        <SolidQR text={queryParameters?.deviceCode && queryParameters?.userCode ? `https://www.${window?.location?.host === 'waf-starhub-voltweb-stv-p002.ifs.vubiquity.com' || window?.location?.host === 'waf-starhub-voltweb-stv-p002.sh-ifs.com' ? 'starhubtvplus.com' : 'uat.starhubtvplus.com'}/qrlogin?deviceCode=${queryParameters?.deviceCode}&userCode=${queryParameters?.userCode}` : ''} options={{
                        width: 500, errorCorrectionLevel:'low'
                        }}/>
                    </div>
                </div>
                <div class="qr-description">{getI18n()?.formatMessage({id: 'QR_LOGIN_SCAN'})}</div>
        </>
    )
}
